import React from 'react'
import {
    Link,
  } from "react-router-dom";

export const OnlineStore = (props) => {
    return (
        <div>
            <div className="container">

                <h3 className="mt-4 mb-3">BronzeTag Online Store
            
                </h3>

                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item active">Online Store</li>
                </ol>

                <div className="row">
                <div class="col-lg-12">
                    <p>Give your customers the flexibility to shop from the comfort of their homes and pickup their orders once ready in store or at designated pickup locations.</p>
                </div>
                
                </div>
            
            
            
            

    
    

    

            </div>
        </div>
    )
}